const initialState = [];

function reducer(state = initialState, action) {
    if (action.type === 'ISSUE_ROOT_CAUSES_SUCCESS') {
        return action.payload;
    }

    return state;
}

export default reducer;
